<template>
  <header :class="{ 'fixed': fixed }">
     <Logo id="logo" :class="{ 'hide-on-mobile': hideLogoOnMobile }"></Logo>
    <nav-bar :relativeLinks="relativeLinks" id="nav-bar"></nav-bar>
  </header>
</template>
<script>

import NavBar from "@/components/NavBar.vue";
import Logo from "@/components/GoodkidLogo.vue";

export default {
  name: "HeaderSection",
  components: {
    NavBar,
    Logo,
  },
  props: {
    relativeLinks: Boolean,
    fixed: Boolean,
    hideLogoOnMobile: Boolean,
  },
};
</script>

<style scoped>
header.fixed {
  position: fixed;
}

header {
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: var(--xs);
  padding: var(--m);
  box-sizing: border-box;
}

#nav-bar {
  margin-top: 10px;
}

#logo {
  padding-top: 25px;
  padding-left: 25px;
}

@media screen and (max-width: 768px) {
  header {
    position: relative !important;
    flex-direction: column-reverse;
    align-items: center;
  }

  header.fixed {
    position: absolute !important;
  }

  #logo {
    transform: scale(0.9) translate(0px, -10px);
    padding-top: 3px;
    padding-left: 0;
  }

  #logo.hide-on-mobile {
    display: none;
  }
}
</style>